getUserPortalData